module.exports = __webpack_public_path__ + "static/media/rotor-adapters.607145e8.svg";